<template>
  <div class="info-one">
    <van-cell-group title="基本资料">
      <van-field :disabled="true" label="证券账号" v-model="editItem.stockAccount" input-align="right"
        placeholder="请输入证券账号" />
      <van-field :disabled="true" label="姓名(中文)" v-model="editItem.cnName" input-align="right"
        placeholder="请输入姓名(中文)" />
      <van-field :disabled="true" label="姓名(英文/拼音)" label-width="120px" v-model="editItem.enName" input-align="right"
        placeholder="请输入姓名(英文/拼音)" />
      <van-field :disabled="true" label="已绑定手机号" label-width="120px" v-model="editItem.tel" input-align="right" />
    </van-cell-group>
    <van-cell-group title="变更信息">
      <van-cell title="手机号">
        <van-checkbox :disabled="disabled" v-model="showEditPhone" shape="square">变更</van-checkbox>
      </van-cell>
      <van-field v-if="showEditPhone" :disabled="disabled" label="" v-model="editItem.changeTel" input-align="right"
        placeholder="请输入需要修改的新手机号">
        <template #left-icon>
          <div style="display: flex;" @click="handleShowSheet">
            {{ labelNameMap[mobileLabel] }} <van-icon name="arrow-down" />
          </div>
        </template>
      </van-field>
      <van-field :disabled="disabled" label="传真号码" v-model="editItem.faxNum" input-align="right"
        placeholder="请输入传真号码" />
      <van-cell title="E-mail">
        <div style="display: flex;">
          <van-checkbox :disabled="disabled" :modelValue="editItem.emailOperate === 0" shape="square" @update:modelValue="handleClearRadio('emailOperate', $event, 0)">新增</van-checkbox>
          <div style="margin-right: 10px;"></div>
          <van-checkbox :disabled="disabled" :modelValue="editItem.emailOperate === 1" shape="square" @update:modelValue="handleClearRadio('emailOperate', $event, 1)">变更</van-checkbox>
        </div>
      </van-cell>
      <van-field :disabled="disabled" label="" v-model="editItem.email" input-align="right"
        placeholder="邮箱号码恕不接受。P.O.Box will NOT be accepted." />
      <van-cell title="地址">
        <div style="display: flex;">
          <van-checkbox :disabled="disabled" :modelValue="editItem.addressType === 0" shape="square" @update:modelValue="handleClearRadio('addressType', $event, 0)">住宅</van-checkbox>
          <div style="margin-right: 10px;"></div>
          <van-checkbox :disabled="disabled" :modelValue="editItem.addressType === 1" shape="square" @update:modelValue="handleClearRadio('addressType', $event, 1)">办公室</van-checkbox>
        </div>
        <div style="display: flex;margin-top: 10px;">
          <van-checkbox :disabled="disabled" :modelValue="editItem.addressType === 2" shape="square" @update:modelValue="handleClearRadio('addressType', $event, 2)">通讯地址</van-checkbox>
          <div style="margin-right: 10px;"></div>
          <van-checkbox :disabled="disabled" :modelValue="editItem.addressType === 3" shape="square" @update:modelValue="handleClearRadio('addressType', $event, 3)">公司注册地址</van-checkbox>
        </div>
      </van-cell>
      <van-field :disabled="disabled" label="" v-model="editItem.address" input-align="right"
        :placeholder="`请输入${['住宅', '办公室', '通讯地址', '公司注册地址'][editItem.addressType] || ''}`" />
      <input
        v-if="addressPic.length < 3"
        type="file"
        class="image"
        style="filter: alpha(opacity=0); opacity: 0; font-size: 0; height: 0; width: 0;"
        id="uploadImageAddress"
        @change="selectFileImage2($event, 'addressPic')"
      />
      <label :for="disabled ? '' : 'uploadImageAddress'" @click="handleShwoTip('addressPic')">
        <van-cell-group>
          <van-cell value="" is-link>
            <div style="display: flex; justify-content: space-between;">
              <div>地址证明</div>
              <span style="font-size: 12px; color: #1989FA;">点击上传地址证明</span>
            </div>
            <div style="font-size: 12px; opacity: 0.7;">支持png,jpg,jpeg ，最多3张，建议文件大小上传5M以内</div>
          </van-cell>
        </van-cell-group>
      </label>
      <div style="margin-left: 15px;margin-top: 10px;">
        <div v-for="(item, idx) in addressPic" :key="item.fileId"
          style="padding-bottom: 5px;padding-top: 5px; display: flex; justify-content: space-between">
          <div v-if="item.name" style="width: 80%;font-size: 12px;opacity: 0.7;">{{ item.name }}</div>
          <img v-else :src="item.url" alt="" style="width: 50px; height: 50px;" />
          <a v-if="!disabled" style="padding-right: 20px; color: red; cursor: pointer;font-size: 14px;flex-shrink: 0;"
            @click="deleteFile2('addressPic', idx)">x</a>
        </div>
      </div>
      <van-cell title="银行户口">
        <div style="display: flex;">
          <van-checkbox :disabled="disabled" :modelValue="editItem.bankOperate === 0" shape="square" @update:modelValue="handleClearRadio('bankOperate', $event, 0)">新增</van-checkbox>
          <div style="margin-right: 10px;"></div>
          <van-checkbox :disabled="disabled" :modelValue="editItem.bankOperate === 1" shape="square" @update:modelValue="handleClearRadio('bankOperate', $event, 1)">变更</van-checkbox>
        </div>
      </van-cell>
      <div>
        <van-field :disabled="disabled" v-model="editItem.bankName" input-align="right" :placeholder="`请输入开户行`">
          <template #label>
            <div style="margin-left: 15px;">开户行</div>
          </template>
        </van-field>
        <van-field :disabled="disabled" v-model="editItem.bankAccountName" input-align="right"
          :placeholder="`请输入银行账户名称`">
          <template #label>
            <div style="margin-left: 15px;">银行账户名称</div>
          </template>
        </van-field>
        <van-field :disabled="disabled" v-model="editItem.bankAccountNum" input-align="right"
          :placeholder="`请输入银行账户号码`">
          <template #label>
            <div style="margin-left: 15px;">银行账号号码</div>
          </template>
        </van-field>
      </div>
      <van-button v-if="!showNewBank && !disabled" @click="showNewBank = true" block size="small" icon="plus"
        style="color: #1989FA;">添加银行</van-button>
      <div v-else style="position: relative;">
        <div style="height: 1px;background: #969799;margin-left: 20px; margin-right: 20px; opacity: 0.6;"></div>
        <div
          style="position: absolute; top: 0px; right: 12px;color: white;z-index: 99; font-size:14px; font-weight: 500; cursor: pointer;background-color: rgba(0,0,0,.7);width: 16px; height: 16px;border-radius: 0 0 0 16px;"
          v-if="showNewBank && !disabled" @click="showNewBank = false" block size="small">
          <div style="position: absolute; top: -3px; right: -2px;width: 16px; height: 16px;display: flex; justify-content: center; align-items: center;">x</div>
        </div>
        <van-field :disabled="disabled" v-model="newBank.bankName" input-align="right" :placeholder="`请输入开户行`">
          <template #label>
            <div style="margin-left: 15px;">开户行</div>
          </template>
        </van-field>
        <van-field :disabled="disabled" v-model="newBank.bankAccountName" input-align="right"
          :placeholder="`请输入银行账户名称`">
          <template #label>
            <div style="margin-left: 15px;">银行账户名称</div>
          </template>
        </van-field>
        <van-field :disabled="disabled" v-model="newBank.bankAccountNum" input-align="right" :placeholder="`请输入银行账户号码`">
          <template #label>
            <div style="margin-left: 15px;">银行账号号码</div>
          </template>
        </van-field>
        <div style="height: 1px;background: #969799;margin-left: 20px; margin-right: 20px; opacity: 0.6;"></div>
      </div>
      <input
        v-if="bankPic.length < 5"
        type="file"
        class="image"
        style="filter: alpha(opacity=0); opacity: 0; font-size: 0; height: 0; width: 0;"
        id="uploadImageBankPic"
        accept="image/*,application/pdf"
        @change="selectFileImage2($event, 'bankPic')"
      />
      <label :for="disabled ? '' : 'uploadImageBankPic'" @click="handleShwoTip('bankPic')">
        <van-cell-group>
          <van-cell is-link>
            <div style="display: flex; justify-content: space-between;">
              <div>汇款凭证</div>
              <span style="font-size: 12px; color: #1989FA;">点击上传汇款凭证、银行月结单</span>
            </div>
            <div @click.stop.prevent="showNewBankDialog" block size="small" icon="plus"
              style="color: #1989FA;font-size: 12px;display: inline-block; width: 150px;">
              查看入金账户
            </div>
            <div style="font-size: 12px; opacity: 0.7; float: left;">支持.png.jpg.jpeg.pdf,最多5张，建议文件大小上传5M以内</div>
          </van-cell>
        </van-cell-group>
      </label>
      <div style="margin: 10px 15px;">
        <div v-for="(item, idx) in bankPic" :key="item.name"
          style="padding-bottom: 5px;padding-top: 5px; display: flex; justify-content: space-between">
          <div v-if="item.name" style="width: 80%;font-size: 12px;opacity: 0.7;">{{ item.name }}</div>
          <img v-else :src="item.url" alt="" style="width: 50px; height: 50px;" />
          <a v-if="!disabled" style="padding-right: 20px; color: red; cursor: pointer;font-size: 14px;flex-shrink: 0;"
            @click="deleteFile2('bankPic', idx)">x</a>
        </div>
      </div>
    </van-cell-group>
    <van-cell-group>
      <van-field :disabled="disabled" v-model="editItem.other" type="textarea" label="其他" input-align="right"
        placeholder="请输入其他变更信息" rows="2" autosize maxlength="200" />
    </van-cell-group>
    <div style="margin-top: 10px; font-size: 14px; padding: 4px">
      如搬迁往另一国家，请附上新的W-8表格。New W-8BEN Form is required if you relocated to another country.
    </div>
    <input
      v-if="fileList.length < 3"
      type="file"
      class="image"
      style="filter: alpha(opacity=0); opacity: 0; font-size: 0; height: 0; width: 0;"
      id="uploadImage"
      @change="selectFileImage($event)"
    />
    <label :for="disabled ? '' : 'uploadImage'" @click="handleShwoTip('fileList')">
      <van-cell-group>
        <van-cell is-link>
          <div style="display: flex; justify-content: space-between;">
            <div>上传附件</div>
            <span style="font-size: 12px; color: #1989FA;">点击上传</span>
          </div>
          <div style="font-size: 12px; opacity: 0.7;">支持png,jpg,jpeg,pdf 最多3份，建议文件大小上传5M以内</div>
        </van-cell>
      </van-cell-group>
    </label>
    <div style="margin-left: 15px;margin-top: 10px;">
      <div v-for="item in fileList" :key="item.fileId"
        style="padding-bottom: 5px;padding-top: 5px; display: flex; justify-content: space-between">
        <div style="width: 80%;font-size: 12px;opacity: 0.7;">{{ getNewFileName(item.fileName) }}</div>
        <a v-if="!disabled" style="margin-right: 20px; color: red;" @click="deleteFile(item.fileId)">x</a>
      </div>
    </div>
    <van-cell-group title="如已确认更改内容，请签名" style="margin: 0px 20px;">
      <div class="image" @click="handleShowSignatrue">
        <van-image v-if="subAccountSign" width="250px" height="100px" fit="contain" :disabled="disabled"
          :src="subAccountSign" />
        <div v-else style="height: 100px; line-height: 100px">点击签名</div>
      </div>
    </van-cell-group>
    <div style="width: 100%;text-align: center;margin-bottom: 40px;">
      <van-button class="btn" @click="handleSubmit" type="primary" :loading="loading">
        {{ disabled ? '确定' : '提交' }}
      </van-button>
    </div>
    <div class="signatrueMask" v-show="showSignatrue">
      <div class="signatrue" @touchmove.stop.prevent>
        <canvas ref="signatrue" class="canvas" />
        <div class="btns">
          <van-button type="danger" class="btn" @click="handleClearSignatrue"> 清除 </van-button>
          <van-button type="default" class="btn" @click="handleCancelSignatrue"> 取消 </van-button>
          <van-button type="primary" class="btn" @click="handleOkSignatrue"> 确定 </van-button>
        </div>
      </div>
    </div>
    <van-action-sheet v-model:show="showSheet" :actions="actions" @select="onSelect" cancel-text="取消"
      close-on-click-action />
  </div>
</template>

<script>
import SignaturePad from "signature_pad";
import {
  Button, Icon, CellGroup, Field, Cell, Image as VanImage,
  Checkbox, CheckboxGroup, RadioGroup, Radio, Dialog, Divider, ActionSheet,
} from 'vant';
import { useStore } from 'vuex';
import { onMounted, reactive, ref, toRaw } from 'vue';
import httpApi from '../../utils/httpApi';
import uploadImage from '../upload/uploadImage';

export default {
  name: 'Home',
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.name]: Dialog,
    [Divider.name]: Divider,
    [ActionSheet.name]: ActionSheet,
  },
  data() {
    return {
      showSheet: false,
      labelNameMap: {
        "+86": "中国大陆 +86",
        "+852": "中国香港 +852",
        "+853": "中国澳门 +853",
        "+886": "中国台湾 +886"
      },
      actions: [
        { name: "中国大陆 +86", value: "+86" },
        { name: "中国香港 +852", value: "+852" },
        { name: "中国澳门 +853", value: "+853" },
        { name: "中国台湾 +886", value: "+886" }
      ]
    };
  },
  methods: {
    handleClearRadio(type, value, nValue) {
      this.editItem[type] = '';
      if (value) this.editItem[type] = nValue;
    },
    async selectFileImage(event) {
      const file = event.target.files[0];
      if (file.size > 5 * 1024 * 1024) {
        this.$toast('文件大小超过5MB，请重新上传！');
        return;
      }
      const data = new FormData();
      data.append('file', file, file.name);
      data.append('fileName', file.name);
      const { data: result } = await httpApi.changeInfoUploadFile(data);
      this.fileList.push(result.data);
    },
    handleShowSheet() {
      this.showSheet = true;
    },
    onSelect(item) {
      this.mobileLabel = item.value;
      this.showSheet = false;
    },
    deleteFile(fileId) {
      this.fileList = this.fileList.filter(item => item.fileId !== fileId);
    },
    getNewFileName(fileName) {
      const nameList = fileName.split('.');
      const suffix = nameList.pop();
      const name = nameList.join('.');
      if (name.length < 8) return fileName;
      const startName = name.slice(0, 5);
      const endName = name.slice(-2);
      return `${startName}...${endName}.${suffix}`;
    },
    handleShwoTip(key) {
      if (key === 'bankPic' && this.bankPic.length >= 5) {
        this.$toast('仅支持最多5张图片/PDF');
      } else if (key === 'addressPic' && this.addressPic.length >= 3) {
        this.$toast('仅支持最多3张图片');
      } else if (key === 'fileList' && this.fileList.length >= 3) {
        this.$toast('仅支持最多3份附件');
      }
    },
    async selectFileImage2(event, type) {
      const file = event.target.files[0];
      if (file.size > 5 * 1024 * 1024) {
        this.$toast('文件大小超过5MB，请重新上传！');
        return;
      }
      if (file.type === 'application/pdf') {
        const data = new FormData();
        data.append('file', file, file.name);
        data.append('fileName', file.name);
        const { data: result } = await httpApi.changeInfoUploadFile(data);
        if (type === 'bankPic') {
          this.bankPic.push({ name: this.getNewFileName(result.data.fileName), fileName: result.data.fileName, fileId: result.data.fileId });
        }
      } else {
        uploadImage(file, type, (photo, preName) => {
          if (type === 'addressPic') {
            this.addressPic.push({ name: this.getNewFileName(preName), url: photo });
          }
          if (type === 'bankPic') {
            this.bankPic.push({ name: this.getNewFileName(preName), url: photo });
          }
        }, () => true);
      }
    },
    deleteFile2(type, idx) {
      if (type === 'addressPic') {
        this.addressPic.splice(idx, 1);
      }
      if (type === 'bankPic') {
        this.bankPic.splice(idx, 1);
      }
    },
    showNewBankDialog() {
      Dialog.alert({
        title: '入金账户',
        messageAlign: 'left',
        confirmButtonText: '我知道了',
        confirmButtonColor: 'rgba(0,0,0,0.6)',
        message: `
港币存款
银行名称： DBS Bank (Hong Kong) Limited
SWIFT码： DHBKHKHHXXX
户口名称： BEEVEST SECURITIES LIMITED
银行代码： 016
账户号码： 478-002183148
附注：“Client Account Name” & “Account Number”
`,
      });
    },
    // 显示签名
    handleShowSignatrue() {
      if (this.disabled) return;
      this.showSignatrue = true;
      this.$refs.signatrue.width = window.innerWidth - 44;
      this.$refs.signatrue.height = window.innerHeight - 46;
      // 获取到签名数据之后执行
      this.signaturePad = new SignaturePad(this.$refs.signatrue, {
        minWidth: 1,
        maxWidth: 5,
      });
    },

    // 签名确认
    handleOkSignatrue() {
      const data = this.signaturePad && this.signaturePad.toDataURL();
      if (this.signaturePad.isEmpty()) {
        this.subAccountSign = "";
        this.showSignatrue = false;
      } else {
        this.rotateBase64Image(data);
      }
    },

    // 签名清除
    handleClearSignatrue() {
      return this.signaturePad.clear();
    },

    // 签名取消
    handleCancelSignatrue() {
      this.showSignatrue = false;
    },

    // 图片旋转
    rotateBase64Image(base64data) {
      const image = new Image();
      image.src = base64data;

      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.height = image.width;
        canvas.width = image.height;
        const ctx = canvas.getContext("2d");
        ctx.translate(Math.floor(image.height / 2), Math.floor(image.width / 2));
        ctx.rotate((-90 * Math.PI) / 180);
        ctx.drawImage(image, -image.width / 2, -image.height / 2);
        this.showSignatrue = false;
        this.subAccountSign = canvas.toDataURL();
      };
    },
    async handleSubmit() {
      if (this.disabled) {
        this.$router.push({ path: '/change/result' });
        return;
      }
      if (!this.subAccountSign) {
        this.$toast('请填写签名');
        return;
      }
      const params = toRaw(this.editItem);
      if (params.address && !this.addressPic.length) {
        this.$toast('请上传地址证明');
        return;
      }
      if ((params.bankOperate === 0 || params.bankOperate === 1) && !this.bankPic.length) {
        this.$toast('请上传银行证明');
        return;
      }
      params.signature = this.subAccountSign;
      params.attachments = JSON.stringify(this.fileList);
      for (let i = 0; i < this.addressPic.length; i += 1) {
        params[`addressPic${i + 1}`] = this.addressPic[i].url;
      }
      let bankPicI = 0;
      for (let i = 0; i < this.bankPic.length; i += 1) {
        if (this.bankPic[i].url) {
          params[`bankPic${bankPicI + 1}`] = this.bankPic[i].url;
          bankPicI += 1;
        }
      }
      const bankFile = [];
      for (let i = 0; i < this.bankPic.length; i += 1) {
        if (this.bankPic[i].fileId) {
          bankFile.push({ fileName: this.bankPic[i].fileName, fileId: this.bankPic[i].fileId });
        }
      }
      params.bankFile = JSON.stringify(bankFile);
      if (this.showNewBank) {
        params.bankOperate = ((params.bankOperate + 1) * 10) + (params.bankOperate + 1);
        params.bankName = JSON.stringify([params.bankName, this.newBank.bankName]);
        params.bankAccountName = JSON.stringify([params.bankAccountName, this.newBank.bankAccountName]);
        params.bankAccountNum = JSON.stringify([params.bankAccountNum, this.newBank.bankAccountNum]);
      }
      if (params.changeTel && this.showEditPhone) {
        params.changeTel = `${this.mobileLabel}-${params.changeTel}`;
      } else {
        params.changeTel = '';
      }
      this.loading = true;
      await httpApi.changeInfoSubmit(params);
      this.loading = false;
      this.$router.push({ path: '/change/result' });
    }
  },
  setup() {
    const showSignatrue = ref(false);
    const subAccountSign = ref(null);
    const newBank = ref({});
    const showEditPhone = ref(false);
    const showNewBank = ref(false);
    const addressPic = ref([]);
    const bankPic = ref([]);
    const loading = ref(false);
    const fileList = ref([]);
    const signaturePad = null;
    const disabled = ref(false);
    const mobileLabel = ref("+86");
    const editItem = reactive({
      id: '',
      stockAccount: '',
      cnName: '',
      enName: '',
      tel: '',
      changeTel: '',
      faxNum: '',
      email: '',
      emailOperate: null,
      address: '',
      addressType: null,
      bankOperate: null,
      bankName: '',
      bankAccountName: '',
      bankAccountNum: '',
      other: '',
      attachments: [],
      signature: '',
    });
    onMounted(async () => {
      const store = useStore();
      store.commit('setTitleValue', '更改账户资料');
      store.commit('setStepsShow', false);
      const stateResult = await httpApi.changeInfoGetState();
      const result = await httpApi.changeInfoGetData();
      if (stateResult.data.changeState === 4) {
        Object.keys(result.data).forEach(key => {
          if (editItem[key] !== undefined) {
            editItem[key] = result.data[key];
          }
        });
        editItem.changeTel = result.data.changeTel;
        fileList.value = JSON.parse(result.data.attachments || '[]');
        subAccountSign.value = result.data.signature;
        addressPic.value = [result.data.addressPic1, result.data.addressPic2, result.data.addressPic3].filter(v => !!v).map(v => ({ url: v }));
        bankPic.value = [result.data.bankPic1, result.data.bankPic2, result.data.bankPic3, result.data.bankPic4, result.data.bankPic5].filter(v => !!v).map(v => ({ url: v }));
        if (result.data.bankFile) {
          bankPic.value = [...bankPic.value, ...JSON.parse(result.data.bankFile).map(it => ({ ...it, name: it.fileName }))];
        }
        if (editItem.bankOperate >= 10) {
          showNewBank.value = true;
          newBank.value.bankOperate = (editItem.bankOperate % 10) - 1;
          [, newBank.value.bankName] = JSON.parse(editItem.bankName);
          [, newBank.value.bankAccountName] = JSON.parse(editItem.bankAccountName);
          [, newBank.value.bankAccountNum] = JSON.parse(editItem.bankAccountNum);
          editItem.bankOperate = Number.parseInt(editItem.bankOperate / 10, 10) - 1;
          [editItem.bankName] = JSON.parse(editItem.bankName);
          [editItem.bankAccountName] = JSON.parse(editItem.bankAccountName);
          [editItem.bankAccountNum] = JSON.parse(editItem.bankAccountNum);
        }
        if (editItem.changeTel) {
          showEditPhone.value = true;
          const [countryCode, phone] = editItem.changeTel.split('-');
          mobileLabel.value = countryCode;
          editItem.changeTel = phone;
        }
      } else if (stateResult.data.changeState === 1 || stateResult.data.changeState === 2) {
        Object.keys(result.data).forEach(key => {
          if (editItem[key] !== undefined) {
            editItem[key] = result.data[key];
          }
        });
        editItem.changeTel = result.data.changeTel;
        disabled.value = true;
        fileList.value = JSON.parse(result.data.attachments || '[]');
        subAccountSign.value = result.data.signature;
        addressPic.value = [result.data.addressPic1, result.data.addressPic2, result.data.addressPic3].filter(v => !!v).map(v => ({ url: v }));
        bankPic.value = [result.data.bankPic1, result.data.bankPic2, result.data.bankPic3, result.data.bankPic4, result.data.bankPic5].filter(v => !!v).map(v => ({ url: v }));
        if (result.data.bankFile) {
          bankPic.value = [...bankPic.value, ...JSON.parse(result.data.bankFile).map(it => ({ ...it, name: it.fileName }))];
        }
        if (editItem.bankOperate >= 10) {
          showNewBank.value = true;
          newBank.value.bankOperate = (editItem.bankOperate % 10) - 1;
          [, newBank.value.bankName] = JSON.parse(editItem.bankName);
          [, newBank.value.bankAccountName] = JSON.parse(editItem.bankAccountName);
          [, newBank.value.bankAccountNum] = JSON.parse(editItem.bankAccountNum);
          editItem.bankOperate = Number.parseInt(editItem.bankOperate / 10, 10) - 1;
          [editItem.bankName] = JSON.parse(editItem.bankName);
          [editItem.bankAccountName] = JSON.parse(editItem.bankAccountName);
          [editItem.bankAccountNum] = JSON.parse(editItem.bankAccountNum);
        }
        if (editItem.changeTel) {
          showEditPhone.value = true;
          const [countryCode, phone] = editItem.changeTel.split('-');
          mobileLabel.value = countryCode;
          editItem.changeTel = phone;
        }
      } else {
        const { stockAccount, cnName, enName, tel } = result.data;
        editItem.stockAccount = stockAccount;
        editItem.cnName = cnName;
        editItem.enName = enName;
        editItem.changeTel = '';
        editItem.tel = tel;
      }
    });
    return {
      editItem,
      signaturePad,
      newBank,
      showEditPhone,
      addressPic,
      bankPic,
      showSignatrue,
      showNewBank,
      loading,
      subAccountSign,
      fileList,
      disabled,
      mobileLabel,
    };
  },
};
</script>

<style lang="less">
.info-one {
  text-align: left;

  .van-cell__title {
    width: 120px;
    flex-basis: 120px;
    flex-shrink: 0;
    flex-grow: 0;
  }

  .check-group {
    width: 300px;
    display: flex;
    justify-content: space-around;
    align-items: space-around;
    flex-wrap: wrap;

    &>div {
      flex-basis: 50%;
    }
  }

  .icon {
    display: inline;
    position: relative;
    top: 3px;
    left: 3px;
  }
}

.image {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: @space-2 0;
}

.signatrueMask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  display: flex;

  .signatrue {
    position: relative;
    flex: 1;
    background-color: white;

    .canvas {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 44px;
    }

    .btns {
      position: absolute;
      top: 50px;
      left: 0;
      right: 0;
      display: flex;
      transform: rotate(90deg);
      transform-origin: left bottom;

      .btn {
        width: 50%;
        margin: 0 @space-1;
      }
    }
  }
}

.btn {
  width: 80%;
  margin: @space-0 auto;
  margin-bottom: 0;
}
</style>
